import type { FirebaseApp } from 'firebase/app';

declare global {
  interface Window {
    webkit: any;
    iOSPushCapability: boolean;
    gtag: any;
  }
}

const isWindowUndefined = typeof window === 'undefined';

let app: FirebaseApp;

export async function getFirebaseApp() {
  if (isWindowUndefined) {
    return app;
  }
  if (!app) {
    try {
      const { initializeApp } = await import('firebase/app');
      app = initializeApp({
        apiKey: 'AIzaSyANx4T9P-yk_7_eLIhjcMIOXaRtqp9IJwA',
        authDomain: 'mildang-a1cdd.firebaseapp.com',
        databaseURL: 'https://mildang-a1cdd.firebaseio.com',
        projectId: 'mildang-a1cdd',
        storageBucket: 'mildang-a1cdd.appspot.com',
        messagingSenderId: '974697893751',
        appId: '1:974697893751:web:83633c8a835c0ceb941b72',
        measurementId: 'G-GQTDCK0J3V',
      });
    } catch (e) {}
  }

  return app;
}
